// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__27KdB","rightAdornment":"Header_rightAdornment__2A8Xj"};